import React from 'react';
import { Link } from 'react-router-dom';
import apiConfig from '../../config/api';
import { useTranslation } from 'react-i18next';
import AdminMenu from './AdminMenu';
import LanguageSelector from '../layout/LanguageSelector';
import { useAuth } from '../../api/auth/AuthContext';
import { getAuthUser } from '../../api/auth/authService';

type AdminHeaderProps = {
  subtitleKey?: string; // Clave i18n de subtítulo del área actual
  subtitleKeys?: string[]; // Claves i18n para componer "Área | Sección"
};

const AdminHeader: React.FC<AdminHeaderProps> = ({ subtitleKey, subtitleKeys }) => {
  const { t } = useTranslation();
  const { user, roles, logout } = useAuth();

  const primaryRole = roles?.[0] || 'admin_general';
  const userName = user?.name || 'Admin';
  const cachedUser = getAuthUser();
  const rawAvatar = (user?.claims?.attributes?.avatar_url || cachedUser?.claims?.attributes?.avatar_url || '');
  const userAvatar = rawAvatar && rawAvatar.startsWith('/uploads')
    ? `${apiConfig.assetsBaseUrl}${rawAvatar}`
    : (rawAvatar || '/assets/images/logo.png');

  return (
    <div className="bg-white border-b">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        {/* Top bar mejorado: título/subtítulo a la izquierda, logo centrado, acciones a la derecha */}
        <div className="grid grid-cols-3 items-center gap-4">
          {/* Izquierda: título + subtítulo */}
          <div className="flex flex-col">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
              {t('admin.header.title', 'Panel de Administración')}
            </h1>
            <span className="text-sm md:text-base text-gray-600">
              {subtitleKeys && subtitleKeys.length > 0
                ? subtitleKeys.map((k) => t(k)).join(' | ')
                : subtitleKey
                ? t(subtitleKey)
                : ''}
            </span>
          </div>
          {/* Centro: logo */}
          <div className="flex justify-center">
            <Link to="/admin/dashboard" className="flex items-center">
              <img
                src="/assets/images/logo.png"
                alt="i3D"
                className="h-9 w-auto object-contain"
              />
            </Link>
          </div>
          {/* Derecha: acciones */}
          <div className="flex items-center justify-end gap-3">
            <LanguageSelector />
            <Link to="/admin/profile" className="flex items-center gap-2">
              <img
                src={userAvatar}
                alt={userName}
                className="h-9 w-9 rounded-full border border-gray-200 object-cover"
              />
            </Link>
            <button
              onClick={logout}
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
              title={t('admin.header.role', 'Rol') + ': ' + primaryRole}
            >
              {t('admin.header.logout', 'Salir')}
            </button>
          </div>
        </div>

      {/* Menu bar */}
        <div className="mt-4">
          <div className="hidden md:block">
            <AdminMenu />
          </div>
          <div className="md:hidden w-full">
            <AdminMenu mobile />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;